/** Left nav for server settings (ids match settingsSearchIndex keys). */
export const SETTINGS_NAV = [
  {
    id: "profile",
    label: "Profile",
    items: [
      { id: "kamiProfile", title: "Kami Profile" },
      { id: "serverHost", title: "Server Host" },
    ],
  },
  {
    id: "onboarding",
    label: "Join & roles",
    items: [
      { id: "welcome", title: "Welcome Message" },
      { id: "leave", title: "Leave Message" },
      { id: "roles", title: "Roles & Verification" },
      { id: "verification", title: "Verification Panel" },
    ],
  },
  {
    id: "channels",
    label: "Channels & stats",
    items: [
      { id: "channels", title: "System Channels" },
      { id: "serverStats", title: "Server Stats Counters" },
    ],
  },
  {
    id: "moderation",
    label: "Moderation",
    items: [
      { id: "guardian", title: "Warden Settings" },
      { id: "automod", title: "Auto Moderation" },
      { id: "tickets", title: "Support Tickets" },
      { id: "staffTasks", title: "Staff Tasks" },
      { id: "staffQuota", title: "Staff Quotas" },
    ],
  },
  {
    id: "progression",
    label: "Leveling & boosts",
    items: [
      { id: "leveling", title: "Global Leveling" },
      { id: "serverLeveling", title: "Server Ranks & Roles" },
      { id: "boosting", title: "Server Boosting" },
      { id: "donorSupport", title: "Donor Support", homeOnly: true },
    ],
  },
  {
    id: "community",
    label: "Community",
    items: [
      { id: "giveaways", title: "Giveaways" },
      { id: "applications", title: "Applications" },
      { id: "qotd", title: "Question of the Day" },
      { id: "confessions", title: "Confessions" },
      { id: "partnerships", title: "Partnerships" },
      { id: "streamAlerts", title: "Stream Alerts" },
      { id: "shop", title: "Shop" },
      { id: "rolePanels", title: "Role Panels" },
      { id: "colorPanels", title: "Color Role Panels" },
    ],
  },
];

export function resolveSettingsNav({ showProgressionAdmin = false } = {}) {
  return SETTINGS_NAV.map((group) => ({
    ...group,
    items: group.items.filter(
      (item) => !item.homeOnly || showProgressionAdmin,
    ),
  })).filter((group) => group.items.length > 0);
}

export function findNavItem(sectionId, showProgressionAdmin) {
  for (const group of resolveSettingsNav({ showProgressionAdmin })) {
    const item = group.items.find((entry) => entry.id === sectionId);
    if (item) return { ...item, groupLabel: group.label };
  }
  return null;
}

export function defaultSectionId(showProgressionAdmin) {
  return resolveSettingsNav({ showProgressionAdmin })[0]?.items[0]?.id || "kamiProfile";
}
